import { NewslettersEffects } from './newsletters.effect';

export const effects = [NewslettersEffects];
export * from './newsletters.effect';
